import { Abstract, Coordinates, NullableCoordinates } from '@/types/commons/commons.types';
import { GridLayout } from '@/types/config/gridLayout.types';

export enum ContextEnum {
  LIVE = 'LIVE',
  DOUBT_LAD = 'DOUBT_LAD',
  DOUBT_PERIM = 'DOUBT_PERIM',
  REPLAY = 'REPLAY',
  STAT_DATA = 'STAT_DATA',
}

export interface GlobalScreenConfiguration extends Abstract {
  id: number;
  code: string;
  name: string;
  site: string;
  screenConfigurations: ScreenConfiguration[];
  position: Coordinates;
  mapZoom: number;
}

export type ActiveGlobalScreenConfiguration = Omit<GlobalScreenConfiguration, 'screenConfigurations'> & {
  screenConfigurations: ActiveScreenConfiguration[];
};

export interface AbstractScreenConfiguration {
  code: string;
  context: ContextEnum;
}

export interface ScreenConfiguration extends AbstractScreenConfiguration {
  gridLayoutCode: string | null;
  gridLayout?: never;
}

export interface ActiveScreenConfiguration extends AbstractScreenConfiguration {
  gridLayoutCode?: never;
  gridLayout: GridLayout | null;
}

export type GlobalScreenConfigurationWithNullableCoordinates = Omit<GlobalScreenConfiguration, 'position'> & {
  position: NullableCoordinates;
};
